import React from 'react'
import MetaTags from '../../seo/MetaTags'
import useFirstAddressWithTownSeoPostcode from '../../seo/useFirstAddressWithTownSeoPostcode'

export const getMeta = (town, postcode) => {
  return {
    title: `ZFE ${town} (${postcode}) : les zones de restrictions Crit’Air - Mappy`,
    description: `Affichez sur la carte, la zone à faible émission de ${town} (${postcode})`
  }
}

export const ZfeCityMetaManager = () => {
  const { town, postcode } = useFirstAddressWithTownSeoPostcode()
  return <MetaTags {...getMeta(town, postcode)} />
}

export default ZfeCityMetaManager
